<template>
  <div>
    <script id="editor" v-if="id == 'ue1'" type="text/plain"></script>
    <script id="editor2" v-if="id == 'ue2'" type="text/plain"></script>
    <script id="editor3" v-if="id == 'ue3'" type="text/plain"></script>
    <script id="editor4" v-if="id == 'ue4'" type="text/plain"></script>
    <Upload v-if="isupload" :config="{total:9}" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
  import Upload from '@/components/file/Upload';
  export default {
    components:{Upload},
    name: 'ue',
    data() {
      return {
        editor: null,
        editor2: null,
        editor3: null,
        editor4: null,
        isupload:false,
        hasCallback: false,
        callback: null,
        this_config:{
          //不需要工具栏漂浮
          autoFloatEnabled:false
        },
        current_ueindex:"",
      }
    },
    props: {
      text1: String,
      text2: String,
      text3: String,
      text4: String,
      config: Object,
      id:String
    },
    created() {
      /*富文本框的默认选择图片方式，改成自定义的选择方式*/
      window.openUpload = this.openUpload;
    },
    watch:{

      text1(val,oldval){
        var self = this;
        // if(val != oldval){//说明不在当前组件下操作
        //   setTimeout(function(){
        //     self.editor.setContent(val);
        //   },300)
        // }
      },
    text2(val,oldval){
        var self = this;
        // if(val != oldval){//说明不在当前组件下操作
        //   setTimeout(function(){
        //     self.editor2.setContent(val);
        //   },300)
        // }

      }
    },
    mounted() {
      var self =this;
      Object.assign(self.this_config,self.config);
      if(self.id == "ue1"){
        self.editor = window.UE.getEditor('editor', self.this_config);
        self.editor.addListener('ready', (e) => {
          self.editor.setContent(self.text1);
        });
        /*监听富文本内容变化，有变化传给调用组件的页面*/
        self.editor.addListener('contentChange', (e) => {
          self.$emit('contentChange',self.editor.getContent());
        });
      }else  if(self.id == "ue2"){
        self.editor2 = window.UE.getEditor('editor2', self.this_config);
        self.editor2.addListener('ready', (e) => {
          self.editor2.setContent(self.text2);
        });
        /*监听富文本内容变化，有变化传给调用组件的页面*/
        self.editor2.addListener('contentChange', (e) => {
          self.$emit('contentChange2',self.editor2.getContent());
        });
      }else  if(self.id == "ue3"){
        self.editor3 = window.UE.getEditor('editor3', self.this_config);
        self.editor3.addListener('ready', (e) => {
          self.editor3.setContent(self.text3);
        });
        /*监听富文本内容变化，有变化传给调用组件的页面*/
        self.editor3.addListener('contentChange', (e) => {
          self.$emit('contentChange3',self.editor3.getContent());
        });
      }else  if(self.id == "ue4"){
        self.editor4 = window.UE.getEditor('editor4', self.this_config);
        self.editor4.addListener('ready', (e) => {
          self.editor4.setContent(self.text4);
        });
        /*监听富文本内容变化，有变化传给调用组件的页面*/
        self.editor4.addListener('contentChange', (e) => {
          self.$emit('contentChange4',self.editor4.getContent());
        });
      }
     
    },
    methods: {

      /*获取富文本框内容*/
      getUEContent() {
        var self = this;
        if(self.id == "ue1"){
          return self.editor.getContent()
        }else if(self.id == "ue2"){
          return self.editor2.getContent()
        }else if(self.id == "ue3"){
          return self.editor3.getContent()
        }else if(self.id == "ue4"){
          return self.editor4.getContent()
        }
       
      },

      /*打开选择图片*/
      openUpload: function(callback) {
        this.isupload = true;
        if (callback) {
          this.hasCallback = true;
          this.callback = callback;
        }
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          this.hasCallback && this.callback(e);
        }
        this.isupload = false;
      },
    },

    /*销毁*/
    destroyed() {
      if(this.id == "ue1"){
          this.editor.destroy()
      }else if(this.id == "ue2"){
          this.editor2.destroy()
      }else if(this.id == "ue3"){
          this.editor3.destroy()
      }else if(this.id == "ue4"){
          this.editor4.destroy()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UE1.vue